import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

// servicios 
import { AuxDataService } from './datos/auxData.service';
import { UsuarioService } from './datos/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class CronTotalesMenuService implements OnDestroy {

  private intervalSubscription?: Subscription;
  private readonly INTERVAL_TIME = 30000; // 30 segundos

  // Propiedad para almacenar los totales
  public totales: any = {};

  constructor(
    public auxDataSrv: AuxDataService,
    private usuarioSrv: UsuarioService,
  ) {
    // Escuchar cambios de autenticación para iniciar/detener el cron automáticamente (Solo para Roles Desktop, No pda)
    this.usuarioSrv.onAuthChange.subscribe((logged) => {
      if (logged) {
        this.usuarioSrv.getProfile().subscribe(resp => {
          if (resp.data.profile.role !== 'usuario') {
            this.iniciarActualizacionPeriodica();
          }
        });
      } else {
        this.detenerActualizacionPeriodica();
      }
    });
  }

  /**
   * Iniciar la actualización periódica de totales en el menú
   */
  iniciarActualizacionPeriodica(): void {
    // Actualizar inmediatamente
    this.getTotalesApi();

    // Luego cada X segundos
    this.intervalSubscription = interval(this.INTERVAL_TIME)
      .subscribe(() => {
        this.getTotalesApi();
      });
  }

  /**
   * Detener la actualización periódica
   */
  detenerActualizacionPeriodica(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = undefined;
    }
  }

  /**
   * Obtener los totales del menú
   */
  public getTotalesApi(): void {

    this.auxDataSrv.getTotalesApi().pipe(
      catchError((err) => {
        // Error de red (servidor caído) o sesión expirada (401/403)
        const status: number = err?.status ?? 0;
        if (status === 0 || status === 401 || status === 403) {
          console.warn('🔒 Sin conexión o sesión expirada. Deteniendo cron y cerrando sesión.');
          this.detenerActualizacionPeriodica();
          this.usuarioSrv.logOut();
        }
        return EMPTY; // Suprimir el error para no romper el flujo
      })
    ).subscribe(resp => {
      this.totales.pedidosSinCamp = resp.data.pedidosSinCamp || 0;
      this.totales.entradasPendientes = resp.data.entradasPendientes || 0;
      this.totales.pedidosAccionPendiente = resp.data.pedidosAccionPendiente || 0;

      console.log('📈 Totales actualizados:', this.totales);
    });
  }

  ngOnDestroy(): void {
    this.detenerActualizacionPeriodica();
  }
}